export default __webpack_public_path__ + "static/media/image2.c7123d45.png";